module.exports = __webpack_public_path__ + "img/首页3.7a4f4077.jpg";